import React, { useState } from 'react';
import { Box, Heading, Icon, Skeleton } from '@chakra-ui/react';
import { BsFileEarmarkPdfFill } from "react-icons/bs";

function UserManual() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Box p={8} gap={4}>
      <Heading size="md" mb={4} display="flex" alignItems="center" gap={2}>
        <Icon as={BsFileEarmarkPdfFill} w="20px" h="20px" color="#4B80DE" />
        User Manual
      </Heading>

      <Skeleton isLoaded={!isLoading} borderRadius="md">
        <Box
          as="iframe"
          src="/User-manual.pdf"
          width="100%"
          height="90vh"
          border="none"
          borderRadius="md"
          boxShadow="md"
          pt={4}
          onLoad={() => setIsLoading(false)}
        />
      </Skeleton>
    </Box>
  );
}

export default UserManual;
